import styled from 'styled-components'
import { TypeBodyM } from '../../styles/mixins'
import { useSettings } from '../../contexts/SettingsProvider';
import SidebarCollectionLinks from './SidebarCollectionLinks';
import { useState } from 'react';

interface P {
  [key: string]: any
}

const SidebarCollection: React.FC<P> = ({
  ...props
}: P) => {
  const { collection, }  = useSettings();
  const [activeIndex, setActiveIndex] = useState(-1);

  return (
    <Container {...props}>
        <Links>
          { collection.links?.map((link, index) =>
            <SidebarCollectionLinks 
              title={link.title} 
              links={link.links} 
              key={link._key} 
              index={index}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
            />
          )}
        </Links>
    </Container>
  )
}

const Container = styled.nav``

const Links = styled.nav`
  ${TypeBodyM}
  margin-bottom: 1em;
`

export default SidebarCollection
